export function snapshot(req) {
    return $state.snapshot(req);
}
